import mail from './../assets/images/mail.png';

const Preview = () => {
  return (
    <div className="flex flex-col items-center justify-center text-center h-full">
      <img src={mail} alt="Mail Icon" className="w-9 h-9 mb-4" />

      <p className="text-[11px] text-tab-grey">Select an item to read.</p>
      <p className="text-[11px] text-midblue">
        Click here to always preview item
      </p>
    </div>
  );
};

export default Preview;
